// extracted by mini-css-extract-plugin
export default {"main-content":"NewAccount_main-content__r9Gnq","form":"NewAccount_form__ZPrxa"};